import type { RatesResponse } from "components/pages/Earn/types";
import sortBy from "lodash/sortBy";
import sortedUniqBy from "lodash/sortedUniqBy";

export const getHighestTieredRates = (rates: RatesResponse) => {
  const providerIds = Object.keys(rates);

  const formatted = providerIds?.flatMap((id) =>
    Object.entries(rates[id])
      .filter(([, val]) => Boolean(val?.tierRates))
      .map(([symbol, val]) => ({ ...val, symbol }))
  );

  // Sort from highest -> lowest apyPct, and only allow one entry per currency (basically, get the highest apyPct from multiple providers)
  const sorted = sortedUniqBy(
    sortBy(formatted, (x) => -x.apyPct),
    (x) => x.symbol
  );

  return sorted;
};
